'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFilterCenterFocus = function MdFilterCenterFocus(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 15q2 0 3.5 1.5t1.5 3.5-1.5 3.5-3.5 1.5-3.5-1.5-1.5-3.5 1.5-3.5 3.5-1.5z m11.6 16.6v-6.6h3.4v6.6q0 1.4-1 2.4t-2.4 1h-6.6v-3.4h6.6z m0-26.6q1.4 0 2.4 1t1 2.4v6.6h-3.4v-6.6h-6.6v-3.4h6.6z m-23.2 3.4v6.6h-3.4v-6.6q0-1.4 1-2.4t2.4-1h6.6v3.4h-6.6z m0 16.6v6.6h6.6v3.4h-6.6q-1.4 0-2.4-1t-1-2.4v-6.6h3.4z' })
        )
    );
};

exports.default = MdFilterCenterFocus;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/filter-center-focus.js
// module id = 2872
// module chunks = 0